// Partner Panel API Base URLs
import { baseUrl as envBaseUrl, imageServiceUrl as envImageServiceUrl } from '../config/environment';

// Export from environment configuration
// This allows CI/CD pipelines to set different URLs via environment variables
export const baseUrl = envBaseUrl;
export const imageServiceUrl = envImageServiceUrl;

// Legacy configuration (commented out for reference)
// Production
// export const baseUrl = 'https://apinew.climate-crusaders.com';
// export const imageServiceUrl = 'https://apinew.climate-crusaders.com';

// Local Development
// export const baseUrl = 'http://localhost:5050';
// export const imageServiceUrl = 'http://localhost:5050';
